import {
  PaintRoller, BrickWall, Layers, Grid3x3, Hammer, Wrench,
  Zap, Sprout, Flame, DoorOpen, Rows3, Drill,
} from "lucide-react";

export const CONTACT = {
  company: "BEZALEL PROPERTY SERVICES",
  tagline: "Your Property, Our Priority",
  phoneDisplay: "07465 443131",
  phoneTel: "07465443131",
  email: "bezalelpropertyservices@gmail.com",
  address: "Flat 3, 129 Apollo Avenue, Fairfields, Milton Keynes, MK11 4AQ",
  social: "#BEZALELPROPERTYSERVICES",
  whatsappBase: "https://wa.me/447465443131",
  instagram: "https://instagram.com",
  facebook: "https://facebook.com",
  twitter: "https://twitter.com",
};

// Reliable link opener that works inside sandboxed preview iframes
// (window.location.href / window.open for mailto & wa.me can be blocked).
export const openExternal = (href, newTab = true) => {
  const a = document.createElement("a");
  a.href = href;
  if (newTab) {
    a.target = "_blank";
    a.rel = "noopener noreferrer";
  }
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const whatsappLink = (text) =>
  `${CONTACT.whatsappBase}?text=${encodeURIComponent(text)}`;

// Gmail web compose (opens reliably in a new tab for everyone).
export const gmailCompose = (subject, body) =>
  `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(CONTACT.email)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
  { label: "Home", to: "/", hash: "top" },
  { label: "Services", to: "/", hash: "services" },
  { label: "Portfolio", to: "/", hash: "portfolio" },
  { label: "Careers", to: "/careers", hash: null },
  { label: "Contact Us", to: "/", hash: "contact" },
];

export const SERVICES = [
  {
    name: "Painting",
    sub: "Interior & Exterior",
    icon: PaintRoller,
    image: "https://images.pexels.com/photos/1669754/pexels-photo-1669754.jpeg",
  },
  {
    name: "Brick Work",
    sub: "& Pointing",
    icon: BrickWall,
    image: "https://images.unsplash.com/photo-1585750629386-33bdc1431574?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Plastering",
    sub: "& Rendering",
    icon: Layers,
    image: "https://images.unsplash.com/photo-1523413363574-c30aa1c2a516?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Tiling",
    sub: "Walls & Floors",
    icon: Grid3x3,
    image: "https://images.unsplash.com/photo-1522061541612-28ef361a3045?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Carpentry",
    sub: "& Joinery",
    icon: Hammer,
    image: "https://images.unsplash.com/photo-1659930087003-2d64e33181f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Plumbing",
    sub: "& Installations",
    icon: Wrench,
    image: "https://images.unsplash.com/photo-1676210134188-4c05dd172f89?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Electrical",
    sub: "Installations",
    icon: Zap,
    image: "https://images.pexels.com/photos/34054464/pexels-photo-34054464.jpeg",
  },
  {
    name: "Garden",
    sub: "Maintenance",
    icon: Sprout,
    image: "https://images.unsplash.com/photo-1689728318937-17d24bc0a65c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Boiler & Gas",
    sub: "Heating",
    icon: Flame,
    image: "https://images.unsplash.com/photo-1650551182956-47efa0f90b64?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Doors & Windows",
    sub: "Fitting",
    icon: DoorOpen,
    image: "https://images.unsplash.com/photo-1751486403820-7cf45ebec080?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Flooring",
    sub: "Solutions",
    icon: Rows3,
    image: "https://images.unsplash.com/photo-1560185008-b033106af5c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Handyman",
    sub: "& General Repairs",
    icon: Drill,
    image: "https://images.pexels.com/photos/17063686/pexels-photo-17063686.jpeg",
  },
];

export const SERVICE_OPTIONS = [
  "Painting (Interior & Exterior)",
  "Brick Work & Pointing",
  "Plastering & Rendering",
  "Tiling (Walls & Floors)",
  "Carpentry & Joinery",
  "Plumbing & Installations",
  "Electrical Installations",
  "Garden Maintenance",
  "Boiler & Gas Heating",
  "Doors & Windows Fitting",
  "Flooring Solutions",
  "Handyman & General Repairs",
];

export const ACCREDITATIONS = [
  "GAS SAFE REGISTERED",
  "FULLY INSURED",
  "RPCP - OFTEC REGISTERED",
];

export const PILLARS = [
  { title: "Reliable Service", desc: "On time, every time. We show up and deliver as promised." },
  { title: "Skilled & Experienced", desc: "Certified tradespeople with years of hands-on expertise." },
  { title: "Quality Workmanship", desc: "Finished to the highest standard, built to last." },
  { title: "Affordable Prices", desc: "Fair, transparent quotes with no hidden costs." },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1748063578185-3d68121b11ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";
